import React,  { Component } from 'react'


class ShowHoursToggler extends Component 
{
    render()
    {
        return (
            <div className={this.props.className}>
                    <span className={"pointer"}>
                        <i 
                            className={this.props.shown ? "fa fa-angle-double-up" : "fa fa-angle-double-down"}
                            onClick={this.props.onClick}
                        />
                    </span>
                </div>
        );
    }
}


export default ShowHoursToggler;
